import React, { useState, useEffect } from 'react';
import {
	Box,
	HStack,
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Td,
	TableContainer,
	useDisclosure,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	Switch,
	Icon,
} from '@chakra-ui/react'
import { LuChevronDown } from 'react-icons/lu'
import CustomModal from '../../../components/CustomModal'
import CustomModalLink from '../../../components/CustomModalLink'
import Create from './Create';
import Edit from './Edit';
import ChangePass from './change-password';
import { fetchWrapper } from '../../../helpers';
import PageLoader from '../../../components/Loader/PageLoader';

function List() {
	const [loading, setLoading] = useState(false);
	const { isOpen, onOpen, onClose } = useDisclosure();
	const { onOpen: onOpenEdit } = useDisclosure();
	const [isOpenEdit, setIsOpenEdit] = useState(false)
	const [modalEditView, setModalEditView] = useState(false)
	const [list, setList] = useState([])

	const [modalHeader, setmodelHeader] = useState('');

	const meClose = () => {

		onClose();
	}

	useEffect(() => {
		loadList();
	}, [])

	const loadList = async () => {
		setLoading(true);
		setList([])
		const url = `${process.env.REACT_APP_API_URL}/user/list?customer_id=0`;
		const data = await fetchWrapper.get(url)
		setList(data.data);
		setLoading(false);
	}

	const meEdit = (rs) => {
		setIsOpenEdit(true);
		setmodelHeader('Update User')
		setModalEditView(<Edit meCloseEdit={meCloseEdit} rs={rs} loadList={loadList} />)
	}

	const meChangePass = (rs) => {
		setIsOpenEdit(true);
		setmodelHeader('Change Password')
		setModalEditView(<ChangePass meCloseEdit={meCloseEdit} rs={rs} loadList={loadList} />)
	}
	const handleActiveInActive = (rs) => {
		const url = `${process.env.REACT_APP_API_URL}/user/update-status`;
		const data = {
			id: rs.id,
			status_id: rs.status_id === 1 ? 2 : 1
		}
		fetchWrapper.post(url, data).then((res) => {
			loadList()
		})
	}

	const handleSuperAdminToggle = (rs) => {
		const url = `${process.env.REACT_APP_API_URL}/user/update-super-admin`;
		const data = {
			id: rs.id,
			super_admin: rs.super_admin === 1 ? 0 : 1,
			customer_id: 0
		}
		fetchWrapper.post(url, data).then((res) => {
			loadList()
		})
	}

	const handleAccountAlertToggle = (rs) => {
		const url = `${process.env.REACT_APP_API_URL}/user/update`;
		const data = {
			id: rs.id,
			account_alert: !rs.account_alert,
			customer_id: 0
		}
		fetchWrapper.post(url, data).then((res) => {
			loadList()
		})
	}

	const meCloseEdit = () => {

		setIsOpenEdit(false);

	}



	return (
		<>
			<PageLoader isLoading={loading} />
			<CustomModalLink
				showModalButtonText={modalHeader}
				modalHeader={modalHeader}
				isOpenEdit={isOpenEdit}
				onCloseEdit={meCloseEdit}
				onOpenEdit={onOpenEdit}

				modalBody={modalEditView}
			/>
			<div className="setting_detail_section">

				<HStack justifyContent="space-between">
					<Box>
						<h2 className="main_heading">Users</h2>
					</Box>
					<Box>
						<HStack>

							<Box>
								<CustomModal
									showModalButtonText="Add New User"
									modalHeader="Add New User"
									isOpen={isOpen}
									onClose={onClose}
									onOpen={onOpen}
									modalBody={<Create meClose={meClose} loadList={loadList} />}
								/>
							</Box>
						</HStack>
					</Box>
				</HStack>



				<div className="table_section">
					<TableContainer width="100%">
						<Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
							<Thead >
								<Tr>

									<Th>Full Name</Th>
									<Th>User ID</Th>
									<Th>Status</Th>
									<Th>Super Admin</Th>
									<Th>Account Alert</Th>


									<Th></Th>
									<Th></Th>





								</Tr>
							</Thead>

							<Tbody fontSize="14px">
								{list.map((rs, index) => {
									return (
										<>
											<Tr>
												<Td>{rs.username}</Td>
												<Td>{rs.email}</Td>
												<Td>
													<Switch
														colorScheme="blue"
														isChecked={rs.status_id === 1 ? true : false} // assuming 'isActive' is your boolean state
														onChange={() => handleActiveInActive(rs)}
													/>
												</Td>
												<Td>
													<Switch
														colorScheme="blue"
														isChecked={rs.super_admin === 1}
														onChange={() => handleSuperAdminToggle(rs)}
													/>
												</Td>
												<Td>
													<Switch
														colorScheme="blue"
														isChecked={!!rs.account_alert}
														onChange={() => handleAccountAlertToggle(rs)}
													/>
												</Td>
												<Td style={{ color: '#1F5AF4', cursor: 'pointer' }} onClick={() => meChangePass(rs)}>Change Password</Td>
												




												<Td style={{ color: "#0000EE" }}>
													<Menu>
														<MenuButton fontSize="14px" >
															Action

															<Icon as={LuChevronDown} />
														</MenuButton>

														<MenuList style={{ minWidth: "20px", border: "1px solid #CCCCCC" }}>
															<MenuItem h="16px" fontSize="12px" onClick={() => meEdit(rs)}>Edit</MenuItem>
														</MenuList>
													</Menu>
												</Td>

											</Tr>
										</>
									)
								})}







							</Tbody>


						</Table>

					</TableContainer>
				</div>

			</div>
		</>
	)
}


export default List
